import React from "react";
import { Modal, Button } from "react-bootstrap";
import '../Tables.css'

const GradeModal = ({ show, onClose, lab, grade }) => {
  if (!lab || !grade) return null;

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="custom-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Информация об оценке</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p><strong>Лабораторная №{lab.number}:</strong> {lab.name}</p>
        <p><strong>Оценка:</strong> {grade.grade}</p>
        <p><strong>Дата:</strong> {grade.date}</p>
        {grade.comment && <p><strong>Комментарий:</strong> {grade.comment}</p>}
        {grade.details && <p><strong>Развернутое обоснование:</strong> {grade.details}</p>}
        {}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GradeModal;
